import React from 'react';
import { Link } from 'react-router-dom';

const Logo = ({ className = '', size = 'medium' }) => {

  const sizes = {
    small: 'h-8',
    medium: 'h-12',
    large: 'h-16'
  };

  return (
    <Link to="/" className={`inline-flex items-center ${className}`}>
      <img
        src="/images/CraftCoat Solutions Logo.png"
        alt="CraftCoat Solutions Logo"
        className={`${sizes[size]} object-contain`}
      />
    </Link>
  );
};

export default Logo;